import React from "react"
import {FormattedMessage} from "react-intl"

import moment from "moment"

export default {
	load() {
		return {
			fields: {
				from: {
					label: <FormattedMessage id="Common.label.from" />,
					rules: "required",
					value: moment()
						.startOf("day")
						.format("YYYY-MM-DD"),
					type: "date"
				},
				to: {
					label: <FormattedMessage id="Common.label.to" />,
					rules: "required",
					value: moment()
						.endOf("day")
						.format("YYYY-MM-DD"),
					type: "date"
				},
				payer_type: {
					label: <FormattedMessage id="Common.label.payerType" />,
					rules: "required",
					value: "Z"
				},
				delivery_code: {
					label: <FormattedMessage id="Delivery.list.modal.deliveryCode" />,
					placeholder: "napr. C10,1"
				}
			}
		}
	}
}
